import React from "react";
import Dialog from "components/organisms/Dialog/Dialog";
import Button from "components/atoms/Button/Button";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";

function AuditConfirmationDialog({ isOpen, close, data, submitComment }) {
  const intl = useIntl();
  const action = data.action === "approved" ? "approve" : "decline";

  return (
    <Dialog
      size="md"
      show={isOpen}
      onHide={close}
      title={intl.formatMessage({
        id: "general.confirm",
        defaultMessage: "Confirm",
      })}
    >
      <p className="mb-30">
        <div>
          <FormattedMessage
            id="billing.confirmation"
            defaultMessage="To {action} this invoice, please click 'Confirm' below"
            values={{ action }}
          />
        </div>
        <div className="mt-2">
          <FormattedMessage
            id="billing.afterConfirmation"
            defaultMessage="Please Note: No changes can be made after confirmation"
          />
        </div>
      </p>
      <div className="d-flex flex-row justify-content-between w-100">
        <Button
          onClick={close}
          className="btn-grey"
          label={intl.formatMessage({
            id: "general.cancel",
            defaultMessage: "Cancel",
          })}
        />
        <Button
          label={intl.formatMessage({
            id: "general.confirm",
            defaultMessage: "Confirm",
          })}
          variant="success"
          onClick={() => submitComment(data)}
        />
      </div>
    </Dialog>
  );
}

export default AuditConfirmationDialog;

AuditConfirmationDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  submitComment: PropTypes.func.isRequired,
};
